import React from "react";
import "./SocialAttachBar.css";
const SocialAttachBar = () => {
  return (
    <div>
      <div className="social">
        <a
          target="blanck"
          className="linkedin"
          href="https://www.linkedin.com/in/themorsehed/"
        >
          <i className="fab fa-linkedin" aria-hidden="true"></i>
        </a>
        <a
          target="blanck"
          className="twitter"
          href="https://twitter.com/Morshed99450152?s=09"
        >
          <i className="fab fa-twitter icons"></i>
        </a>
        <a
          target="blanck"
          className="instagram"
          href="https://www.instagram.com/themorshedinsta/"
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          target="blanck"
          className="youtube"
          href="https://www.youtube.com/channel/UCeZdrwgWbnUoUUXOuaeKdiA"
        >
          <i className="fab fa-youtube"></i>
        </a>
        <a
          target="blanck"
          className="githube"
          href="https://github.com/morshedalam3"
        >
          <i className="fab fa-github" aria-hidden="true"></i>
        </a>
        <a
          target="blanck"
          className="codepen"
          href="https://www.facebook.com/developer.morshed"
        >
          <i className="fab fa-facebook-f" aria-hidden="true"></i>
        </a>
        <div className="line">
          <div className="bottomArrow"></div>
        </div>
      </div>
    </div>
  );
};

export default SocialAttachBar;
